// Get Staff Constants
export const GET_STAFF_REQUEST = 'GET_STAFF_REQUEST';
export const GET_STAFF_SUCCESS = 'GET_STAFF_SUCCESS';
export const GET_STAFF_FAILURE = 'GET_STAFF_FAILURE';

// Add Staff Constants
export const ADD_STAFF_REQUEST = 'ADD_STAFF_REQUEST';
export const ADD_STAFF_SUCCESS = 'ADD_STAFF_SUCCESS';
export const ADD_STAFF_FAILURE = 'ADD_STAFF_FAILURE';

// Delete Staff Constants
export const DELETE_STAFF_REQUEST = 'DELETE_STAFF_REQUEST';
export const DELETE_STAFF_SUCCESS = 'DELETE_STAFF_SUCCESS';
export const DELETE_STAFF_FAILURE = 'DELETE_STAFF_FAILURE';

//Modify Staff Constants
export const EDIT_STAFF_FAILURE = 'EDIT_STAFF_FAILURE';
export const EDIT_STAFF_REQUEST = 'EDIT_STAFF_REQUEST';
export const EDIT_STAFF_SUCCESS = 'EDIT_STAFF_SUCCESS';

// Add Multiple Staff Constants
export const ADD_MULTIPLE_STAFF_REQUEST = 'AADD_MULTIPLE_STAFF_REQUEST';
export const ADD_MULTIPLE_STAFF_SUCCESS = 'ADD_MULTIPLE_STAFF_SUCCESS';
export const ADD_MULTIPLE_STAFF_FAILURE = 'ADD_MULTIPLE_STAFF_FAILURE';
